/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicHolidayKind } from './PublicHolidayKind';
import {
    PublicHolidayKindFromJSON,
    PublicHolidayKindFromJSONTyped,
    PublicHolidayKindToJSON,
    PublicHolidayKindToJSONTyped,
} from './PublicHolidayKind';

/**
 * 
 * @export
 * @interface PublicHolidayResponse
 */
export interface PublicHolidayResponse {
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayResponse
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PublicHolidayResponse
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayResponse
     */
    name: string;
    /**
     * 
     * @type {PublicHolidayKind}
     * @memberof PublicHolidayResponse
     */
    kind: PublicHolidayKind;
}



/**
 * Check if a given object implements the PublicHolidayResponse interface.
 */
export function instanceOfPublicHolidayResponse(value: object): value is PublicHolidayResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function PublicHolidayResponseFromJSON(json: any): PublicHolidayResponse {
    return PublicHolidayResponseFromJSONTyped(json, false);
}

export function PublicHolidayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicHolidayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'name': json['name'],
        'kind': PublicHolidayKindFromJSON(json['kind']),
    };
}

export function PublicHolidayResponseToJSON(json: any): PublicHolidayResponse {
    return PublicHolidayResponseToJSONTyped(json, false);
}

export function PublicHolidayResponseToJSONTyped(value?: PublicHolidayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'name': value['name'],
        'kind': PublicHolidayKindToJSON(value['kind']),
    };
}

